import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import LoadingBar from './ui/LoadingBar';
import _ from 'underscore';

import config from './../config';
import helpers from './../lib/helpers';

function PersonEventsList(props) {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);

	let history = useHistory();

	useEffect(() => {
		if (props.senderId || props.receiverId || props.personId) {
			setLoading(true);
			setData(null);

			let urlParams = [];

			if (props.personId) { // þáttakandi
				urlParams.push('person='+props.personId)
			}

			helpers.fetch(config.apiRoot+'/api/events/?'+urlParams.join('&'), (json) => {
			//helpers.fetch(config.apiRoot+'/api/person/events/?'+urlParams.join('&'), (json) => {
				if (json) {
					setData(json.results);

					if (props.onResponse) {
						props.onResponse(json.results);
					}
				}
				setLoading(false);
			});
		}
	}, [props.senderId, props.receiverId, props.personId]);

	return (
		<div className={'position-relative '+(props.className || '')+(loading ? ' loading' : '')}>
			<LoadingBar />
			{
				data && data.length > 0 &&
				<React.Fragment>
					{
						props.children
					}
					<table className="table">
						<thead>
							<tr>
								<th>Viðburður</th><th>Dagsetning</th><th>Staðsetning</th><th></th>
							</tr>
						</thead>
						<tbody>
							{
								data.map((item, index) => <tr key={index}>
									<td>
										<Link to={helpers.routerUrls['vidburdir_timeline']+item.id}>
											{item.name}
										</Link>
									</td>
									<td>
										{helpers.formatDate(item.date, false, true)}
									</td>
									<td>{helpers.metadataList(item.locations, helpers.routerUrls['stadir'], 'id', 'name', false)}</td>
								</tr>)
							}
						</tbody>
					</table>
					{/*
						<table className="table">
							<thead>
								<tr>
									<th>Viðburður</th><th>Dagsetning</th><th>Efnisatriði</th><th>Hlutverk</th><th></th>
								</tr>
							</thead>
							<tbody>
								{
									data.map((item, index) => <tr key={index}>
										<td>
											<Link to={helpers.routerUrls['vidburdir']+item.id}>
												{item.name}
											</Link>
										</td>
										<td>
											{helpers.formatDate(item.date, false, true)}
										</td>
										<td>{item.program_entry}</td>
										<td>{helpers.metadataList([{
											id: item.status_id,
											name: item.status
										}], helpers.routerUrls['einstaklingar'], 'id', 'name', 'stada', true)}</td>
									</tr>)
								}
							</tbody>
						</table>
					*/}
				</React.Fragment>
			}
		</div>
	)
}

export default PersonEventsList;
